module.exports = __webpack_public_path__ + "img/field.f3590fc0.png";